import Vue from 'vue/dist/vue.esm.js'
import map from 'underscore'
window.ReportRowConfig =
  wait: 2000

Vue.component('report-rows-icebox-row',
  template: JST['report_rows/icebox_row']()
  props: ['reportRow', 'rowsCollection']
  store: KCVS.Stores.ReportRowsStore
  created: ->
    @updateRow = _.debounce(@updateRow, ReportRowConfig.wait)

  mounted: ->
    @updateErrorTooltip()

  data: ->
    errors: {}
    row: @reportRow
    processing: false

  computed:
    expense_type: ->
      if @row.expense_type
        I18n.t("translatable_attributes.report_row.project_types.#{@row.expense_type}")

    state: ->
      if @row.state
        I18n.t("translatable_attributes.report_row.states.#{@row.state}")

    rowId: ->
      "icebox-row-#{@row.id}"

    rowChecked:
      get: ->
        return _.indexOf(@$store.state.selectedIceboxRowIds, @row.id) > -1
      set: (val) ->
        if val
          @$store.commit('addIceboxRowId', @row.id)
        else
          @$store.commit('removeIceboxRowId', @row.id)

    isProblematic: ->
      @row.state == 'problematic'

    totalPaymentAndApplicableAndTotalAmounts: ->
      samePaymentDocRows = _.filter(@rowsCollection, (row) =>
        row.payment_document_number == @row.payment_document_number &&
        row.payment_date == @row.payment_date &&
        row.payment_document_amount == @row.payment_document_amount
      )
      return [] if samePaymentDocRows.length < 2

      paymentDocApplicableAmounts = _.map(samePaymentDocRows, 'applicable_amount')
      paymentDocTotalAmounts = _.map(samePaymentDocRows, 'total_amount')
      paymentDocTotalPaymentAmounts = samePaymentDocRows.map((row) =>
        parseFloat(row.payment_document_amount).toFixed(2) || 0
      )
      paymentDocTotalApplicableAmount = _.reduce(
        paymentDocApplicableAmounts, (memo, amount) ->
          memo + parseFloat(amount)
        , 0
      )
      paymentDocTotalTotalAmount = _.reduce(
        paymentDocTotalAmounts, (memo, amount) ->
          memo + parseFloat(amount)
        , 0
      )
      [
        parseFloat(paymentDocTotalApplicableAmount.toFixed(2)),
        parseFloat(paymentDocTotalTotalAmount.toFixed(2)),
        paymentDocTotalPaymentAmounts
      ]

    smallerThanApplicableSum: ->
      amounts = @totalPaymentAndApplicableAndTotalAmounts
      if amounts.length
        isPaymentAmountSmaller = amounts[2].find((paymentAmount) =>
          amounts[0] > paymentAmount
        )
        if isPaymentAmountSmaller
          return true
        else
          return false

    smallerThanTotalSum: ->
      amounts = @totalPaymentAndApplicableAndTotalAmounts
      if amounts.length
        isPaymentAmountSmaller = amounts[2].find((paymentAmount) =>
          amounts[1] > paymentAmount
        )
        if isPaymentAmountSmaller
          return true
        else
          return false

    applyCorrectErrorColor: ->
      switch true
        when @smallerThanApplicableSum then "smaller-than-applicable-amount-sum"
        when @smallerThanTotalSum then "smaller-than-total-amount-sum"
        when @isProblematic then "is-problematic"
        else null

    fillErrorMessages: ->
      conditions = [
        { condition: @smallerThanApplicableSum, \
          messageKey: \
          "activerecord.errors.report_rows.messages.payment_amount_sum_smaller_than_applicable_amount_sum"},
        { condition: @smallerThanTotalSum, \
          messageKey: \
          "activerecord.errors.report_rows.messages.payment_amount_sum_smaller_than_total_amount_sum"},
        { condition: @isProblematic, \
          messageKey: \
          "activerecord.errors.report_rows.messages.is_problematic"}
      ]

      errorTooltipMessages = ''

      for {condition, messageKey} in conditions
        if condition
          errorTooltipMessages = errorTooltipMessages.concat(
            "<p>#{I18n.t(messageKey)}</p>"
            )

      return errorTooltipMessages

  watch:
    'row.problem_notes': -> # This needs to be before row watcher,
                            # to change the state before ajax update
      @row.problem_notes = @row.problem_notes.replace('\n', ' ')
      if @row.problem_notes
        @row.state = 'problematic'
      else
        @row.state = 'approved'
    row:
      handler: -> @updateRow()
      deep: true

    fillErrorMessages:
      handler: ->
        @updateErrorTooltip()

  methods:
    updateErrorTooltip: ->
      element = @$el.querySelectorAll('[data-toggle="tooltip"]')[0]
      element.setAttribute('data-original-title', @fillErrorMessages)
      $(element).tooltip({
        template: '<div class="tooltip custom-error-tooltip" role="tooltip"> \
            <div class="tooltip-arrow"></div> \
            <div class="tooltip-inner"></div> \
          </div>'
      })

    focusOnOtherInput: (e) ->
      switch e.keyCode
        when 40 # Down arrow
          nextRow = $(@$el).next('tr')
          currentInputName = $(e.target).attr('name')
          nextRow.find("[name='#{currentInputName}']").focus()
        when 13 #Enter
          nextRow = $(@$el).next('tr')
          currentInputName = $(e.target).attr('name')
          nextRow.find("[name='#{currentInputName}']").focus()
        when 38 # Up arrow
          nextRow = $(@$el).prev('tr')
          currentInputName = $(e.target).attr('name')
          nextRow.find("[name='#{currentInputName}']").focus()
        when 37 # Left arrow
          $(e.target).parents('td').prev().find('input', 'textarea').focus()
        when 39 # Right arrow
          if $(e.target).parents('td').next().length > 0 # Not last input in the row
            $(e.target).parents('td').next().find('input', 'textarea').focus()
          else
            $(@$el).next('tr').find('td input').first.focus()

    updateRow: ->
      @errors = {}
      @$store.dispatch('updateIceboxRow', @row)
      .then(() =>
        Helper.flashRow($(@$el), '#bfdf9f')
      )
      .catch((data) =>
        console.log(data)
        @errors = data.responseJSON
        Helper.flashRow($(@$el), '#d10404')
      )

    destroy: ->
      # don't run request twice if button is quickly pressed more than once
      return if @processing
      if confirm I18n.t("javascript.row_delete_confirmation")
        @processing = true
        @$store.dispatch('destroyIceboxRow', @row)
)
